<script>
// import RexTabView from '@/rex-components/RexTabView.vue';
import RexTabsV3 from '@/rex-components/RexTabsV3.vue';
import LogNavSearch from '@/components/Log/LogNavSearch.vue';
import LogNavListOptions from '@/components/Log/LogNavListOptions.vue';
import NoData from '@/rex-components/rex-no-data.vue';
import Loading from '@/rex-components/rex-loading.vue';
import { mapState } from 'vuex';
import { getRouteName } from '@/components/Log/log.types';
import { customSplitString } from '@/utils/helper-function';

export default {
  components: {
    // RexTabView,
    RexTabsV3,
    LogNavSearch,
    LogNavListOptions,
    NoData,
    Loading,
  },
  computed: {
    ...mapState('logState/logCommonState', [
      'queryHeaders',
      'queryDataLoading',
      'isADType',
    ]),
    queryFields() {
      return this.queryHeaders.map((val) => ({
        name: val,
        value: val,
      }));
    },
    getQueryFieldsList() {
      return this.filterList(this.queryFields);
    },
    dispHeadersList() {
      return this.queryHeaders?.length > 0;
    },
  },
  data() {
    return {
      tabs: [this.$t('log.fields')],
      checkedQueryFields: [],
    };
  },
  methods: {
    queryFieldsChange(event) {
      let currQueryFields = this.$route.query.queryFields
        ? customSplitString(this.$route.query?.queryFields, ',')
        : [];

      if (currQueryFields.length > 4 && event.target.checked) {
        event.target.checked = false;
        return;
      }

      if (event.target.checked) {
        currQueryFields.push(`${event.target.value}`);
      } else {
        currQueryFields = currQueryFields.filter(
          (field) => field !== event.target.value,
        );
      }

      this.$router.push({
        name: getRouteName(this.isADType),
        query: { ...this.$route.query, queryFields: currQueryFields.join(',') },
      });
    },
    filterList(list) {
      const search =
        this.$route.query && this.$route.query.search
          ? this.$route.query.search.toLowerCase()
          : '';
      return list.filter(
        (obj) => obj.name && obj.name.toLowerCase().includes(search),
      );
    },
  },
  watch: {
    '$route.query.queryFields': {
      immediate: true,
      handler() {
        this.checkedQueryFields =
          customSplitString(this.$route.query?.queryFields, ',') || [];
      },
    },
  },
};
</script>

<template>
  <div class="queried-tab-box">
    <RexTabsV3
      :tabs="tabs"
      v-if="dispHeadersList && !queryDataLoading"
      activeKey="1"
    >
      <template #tab-1>
        <LogNavSearch :placeholder="$t('log.searchFields')" />
        <LogNavListOptions
          :options="getQueryFieldsList"
          @onChange="queryFieldsChange"
          type="checkbox"
          :checkedItems="checkedQueryFields"
        />
      </template>
    </RexTabsV3>
    <div v-else class="loader-nodata-box">
      <Loading v-if="queryDataLoading" />
      <NoData v-else :message="$t('log.noData')" />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.queried-tab-box {
  height: 59.225rem;
  padding: 0.5rem 1.125rem 0.844rem;
  background-color: $bg-secondary;
  border-radius: 0.25rem;
}
.loader-nodata-box {
  @include flex-center;
  height: 100%;
}
:deep(.nav-tabs) {
  @include flex-center-justify(space-between !important);
  padding-right: 1.5rem;
}
:deep(.nav-link) {
  font-size: 1rem;
}
</style>
